import {HttpClient} from "@angular/common/http";
import {Injectable} from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {ClassificationExternalid} from "../../models/classification-externalid";
import Helpers from "../../utils/helpers";

@Injectable()
export class ClassificationExternalidControllerService {

    private baseUrl: string = environment.BASE_URL;

    constructor(private http: HttpClient) {
    }

    public getClassificationsExternalidsByType(classificationTypeId: string): Observable<ClassificationExternalid[]> {
        return this.http.get(this.baseUrl + "type_classification_externalid/" + classificationTypeId) as Observable<ClassificationExternalid[]>;
    }

    public createClassificationExternalid(classificationTypeId: string, classificationExternalid: ClassificationExternalid): Observable<ClassificationExternalid> {
      Helpers.trimRecursiveObj(classificationExternalid);
      const body = JSON.stringify(classificationExternalid);
      return this.http.post(this.baseUrl + "classification_externalid/" + classificationTypeId, body) as Observable<ClassificationExternalid>;
    }

    public updateClassificationExternalid(classificationExternalid: ClassificationExternalid): Observable<ClassificationExternalid> {
        const body = JSON.stringify(classificationExternalid);
        return this.http.put(this.baseUrl + "classification_externalid", body) as Observable<ClassificationExternalid>;
    }

    public deleteClassificationExternalid(classificationExternalidId: string) {
        return this.http.delete(this.baseUrl + "classification_externalid/" + classificationExternalidId, {responseType: "text"});
    }

    public getClassificationsExternalids(): Observable<ClassificationExternalid[]> {
        return this.http.get(this.baseUrl + "classification_externalid") as Observable<ClassificationExternalid[]>;
    }

    public getClassificationsExternalidsByField(classificationFieldId: string): Observable<ClassificationExternalid[]> {
        return this.http.get(this.baseUrl + "field_classification_externalid/" + classificationFieldId) as Observable<ClassificationExternalid[]>;
    }

    public updateSortOrder(classificationExternalids: ClassificationExternalid[]) {
        const body = JSON.stringify(classificationExternalids);
        return this.http.put(this.baseUrl + "sort_classification_externalids", body, {responseType: "text"});
    }
}
